import FormCK, { TinyFormCK, useEmailForm } from "./FormCK"

export default FormCK
export { TinyFormCK, useEmailForm }
